import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Success from "./pages/Success";
import Admin from "./pages/Admin";
import Resubscribe from "./pages/Resubscribe";
import NewHome from "./pages/NewHome";
import ContactUs from "./pages/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
  return (
    <Router basename={process.env.REACT_APP_BASENAME || null}>
      <Routes>
        <Route path="/">
          <Route exact path="/success/:session_id?" element={<Success />} />
          <Route exact path="/__admin/:adminSection?" element={<Admin />} />
          <Route exact path="/resubscribe/:token" element={<Resubscribe />} />
          <Route exact path="/contact-us" element={<ContactUs />} />
          <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route exact path="/" element={<NewHome />} />
          {/* The preview address keeps working now that the page is home */}
          <Route path="/new-home" element={<Navigate to="/" replace />} />
          <Route path="/*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
